<template>
  <div class="tpage">
    <div class="topbar">
      <el-button type="text" icon="el-icon-arrow-left" @click="$router.push('/tedu')">返回</el-button>
      <span class="title">教师登记</span>
      <el-button type="text" @click="$router.push('/tedu-record')">记录</el-button>
    </div>

    <div class="body">
      <el-card class="form-card" shadow="never">
        <el-form label-position="top" @submit.native.prevent>
          <div class="row2">
            <el-form-item label="教师">
              <el-select v-model="form.teacher" filterable placeholder="输入选择教师"
                         @change="onTeacherChange" style="width:100%">
                <el-option v-for="t in teachers" :key="t.id" :label="t.name" :value="t.name"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="学科">
              <el-input v-model.trim="form.course" maxlength="10" placeholder="选教师后自动带出，可修改"></el-input>
            </el-form-item>
          </div>

          <el-form-item label="分值">
            <el-input-number v-model="form.score" :min="-50" :max="50" :step="1" :precision="0"
                             controls-position="right" style="width:100%"></el-input-number>
            <p class="score-tip">默认 -1（扣分），可为正分，范围 -50 ~ 50</p>
          </el-form-item>

          <el-form-item label="情况说明">
            <el-input v-model.trim="form.market" type="textarea" :rows="3" maxlength="50" show-word-limit
                      placeholder="简要说明登记的事由"></el-input>
          </el-form-item>

          <el-form-item label="现场照片（最多 3 张，可不传）">
            <el-upload action="#" list-type="picture-card" :auto-upload="false" :limit="3"
                       :file-list="fileList" :on-change="onFileChange" :on-remove="onFileRemove"
                       :on-preview="onPreview">
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
        </el-form>

        <el-button type="primary" class="block-btn" :loading="loading" @click="submit">提 交</el-button>
      </el-card>

      <p class="note">说明：教师登记不关联具体班级和课节，记录与查课登记共用一个列表。</p>
    </div>

    <el-dialog :visible.sync="previewVisible" width="90%" custom-class="preview-dialog">
      <img :src="previewUrl" style="width:100%" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import { eduTeacherList, eduAddRegister, eduUploadPicture, getTeacherLogin } from '@/api/teacher.js'

export default {
  name: 'TeacherEduTeacher',
  data() {
    return {
      teachers: [],
      fileList: [],
      loading: false,
      previewVisible: false,
      previewUrl: '',
      form: {
        teacher: '',
        course: '',
        score: -1,
        market: ''
      }
    }
  },
  mounted() {
    if (!getTeacherLogin().token) {
      this.$router.replace('/tlogin')
      return
    }
    this.loadBase()
  },
  methods: {
    loadBase() {
      eduTeacherList()
        .then((teachers) => {
          this.teachers = this.uniqueByName(teachers)
        })
        .catch(() => {
          this.$message.error('教师名单加载失败，请稍后重试')
        })
    },
    /** 教师表里可能同名不同学科，登记只存姓名，按姓名去重 */
    uniqueByName(list) {
      const seen = {}
      return (list || []).filter((t) => {
        if (!t || !t.name || seen[t.name]) return false
        seen[t.name] = true
        return true
      })
    },
    /** 选完教师后自动带出学科，可手动再改 */
    onTeacherChange(name) {
      const t = this.teachers.find((x) => x.name === name)
      if (t && t.subject) {
        this.form.course = t.subject
      }
    },
    onFileChange(file, fileList) {
      this.fileList = fileList.slice(-3)
    },
    onFileRemove(file, fileList) {
      this.fileList = fileList
    },
    onPreview(file) {
      this.previewUrl = file.url || (file.raw ? URL.createObjectURL(file.raw) : '')
      this.previewVisible = true
    },
    submit() {
      if (!this.form.teacher) {
        this.$message.warning('请选择教师')
        return
      }
      if (!this.form.course) {
        this.$message.warning('请填写学科')
        return
      }
      if (!Number.isInteger(this.form.score)) {
        this.$message.warning('分值必须是整数')
        return
      }
      if (!this.form.market) {
        this.$message.warning('请填写情况说明')
        return
      }

      const data = {
        teacher: this.form.teacher,
        course: this.form.course,
        score: this.form.score,
        market: this.form.market
      }

      this.loading = true
      // 与查课登记共用 add_register，不传班级/星期/节次即为教师登记
      eduAddRegister(data)
        .then((res) => {
          if (!res || res.status !== 'success') {
            this.loading = false
            this.$message.error((res && res.message) || '提交失败')
            return
          }
          const registerId = res.data && res.data.id ? res.data.id : ''
          this.uploadPictures(registerId)
        })
        .catch(() => {
          this.loading = false
          this.$message.error('提交失败，请检查网络后重试')
        })
    },
    /** 依次上传照片，失败不影响已提交的登记 */
    uploadPictures(registerId) {
      const files = this.fileList.map((f) => f.raw).filter(Boolean)
      if (!registerId || files.length === 0) {
        this.done(files.length === 0)
        return
      }
      let failed = 0
      const tasks = files.map((file) =>
        eduUploadPicture(file, registerId).catch(() => {
          failed++
        })
      )
      Promise.all(tasks).then(() => {
        this.done(failed === 0)
      })
    },
    done(allOk) {
      this.loading = false
      if (allOk) {
        this.$message.success('提交成功')
      } else {
        this.$message.warning('登记已提交，部分照片上传失败')
      }
      this.fileList = []
      this.form.teacher = ''
      this.form.course = ''
      this.form.score = -1
      this.form.market = ''
      this.$router.push('/tedu-record')
    }
  }
}
</script>

<style scoped lang="scss">
.tpage {
  min-height: 100vh;
  background: #f4f6fb;
}
.topbar {
  background: #fff;
  padding: 10px 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #eef1f7;

  .title {
    font-size: 16px;
    font-weight: 600;
    color: #1f2d3d;
  }
}
.body {
  padding: 12px;
}
.form-card {
  border-radius: 10px;
  border: none;
  ::v-deep .el-card__body {
    padding: 16px 14px 18px;
  }
  ::v-deep .el-form-item {
    margin-bottom: 14px;
  }
  ::v-deep .el-form-item__label {
    padding-bottom: 2px;
    font-size: 13px;
    color: #5b6577;
    line-height: 22px;
  }
}
.row2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}
/* 窄屏（手机竖屏）改为单列，避免下拉框标签被截断 */
@media screen and (max-width: 420px) {
  .row2 {
    grid-template-columns: 1fr;
    gap: 0;
  }
}
.block-btn {
  width: 100%;
  height: 44px;
  font-size: 15px;
  margin-top: 4px;
}
::v-deep .el-upload--picture-card,
::v-deep .el-upload-list--picture-card .el-upload-list__item {
  width: 84px;
  height: 84px;
  line-height: 84px;
}
.score-tip {
  margin: 4px 0 0;
  font-size: 12px;
  color: #a8b0c0;
}
.note {
  margin: 12px 4px 0;
  font-size: 12px;
  color: #a8b0c0;
  line-height: 1.6;
}
</style>
